import { createSlice } from "../helper";
import * as ObjectExtensions from "../../utils/CoreExtensions/ObjectExtensions";

const connectionOnboardingInitialState = {
  groupId: null,
  initialStep: 0,
  applicableSteps: [],
  stepsData: [],
  remainingSteps: [],
  formData: {},
  initialDataLoaded: false,
  asyncDataLoaded: false,
  isSubmitting: false,
  errors: {},
  fromConnectionOnboarding: false,
  source: null
};

const connectionOnboardingSlice = createSlice({
  name: 'connectionOnboarding',
  initialState: connectionOnboardingInitialState,
  reducers: {
    initializeWizard: (state, action) => {
      state.groupId = action.payload.groupId;
      state.initialStep = action.payload.currentStepIndex || 0;
      state.applicableSteps = action.payload.applicableSteps;
      state.stepsData = action.payload.stepsData || [];
      state.remainingSteps = action.payload.remainingSteps || [];
      state.fromConnectionOnboarding = action.payload.fromConnectionOnboarding || false;
      state.source = action.payload.source || null;
      state.initialDataLoaded = true;
    },
    mergeAsyncData: (state, action) => {
      const asyncStepsData = action.payload.stepsData || [];
      // Merge async data into existing steps by key
      asyncStepsData.forEach(asyncStep => {
        const existingStepIndex = state.stepsData.findIndex(step => step.key === asyncStep.key);
        if (existingStepIndex !== -1) {
          state.stepsData[existingStepIndex] = ObjectExtensions.deepMerge(
            state.stepsData[existingStepIndex],
            asyncStep
          );
        } else {
          state.stepsData.push(asyncStep);
        }
      });
      state.asyncDataLoaded = true;
    },
    updateStepFormData: (state, action) => {
      const { stepKey, data } = action.payload;
      state.formData[stepKey] = data;
    },
    updateStepData: (state, action) => {
      const { stepKey, path, value } = action.payload;
      const stepIndex = state.stepsData.findIndex(step => step.key === stepKey);
      if (stepIndex !== -1) {
        state.stepsData[stepIndex][path] = value;
      }
    },
    setSubmitting: (state, action) => {
      state.isSubmitting = action.payload;
    },
    setInitialSnapshot: (state, action) => {
      const { stepKey, snapshot } = action.payload;
      const stepIndex = state.stepsData.findIndex(step => step.key === stepKey);
      if (stepIndex !== -1 && !state.stepsData[stepIndex].initialSnapshot) {
        state.stepsData[stepIndex].initialSnapshot = snapshot;
      }
    },
    setValidationErrors: (state, action) => {
      state.errors = action.payload;
    },
    resetWizard: (state) => {
      Object.assign(state, connectionOnboardingInitialState);
    }
  }
});

export const connectionOnboardingActions = connectionOnboardingSlice.actions;

export default connectionOnboardingSlice;
